"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countriesByRegion = exports.mapBillingCountryToRegion = exports.regionMapping = void 0;
const initCapWords = (str) => {
    const tokens = str.split(' ');
    return tokens
        .map((token) => {
        if (['and', 'of', 'the'].includes(token))
            return token;
        return token.charAt(0).toUpperCase() + token.slice(1);
    })
        .join(' ');
};
exports.regionMapping = {
    ANZ: [
        'Australia',
        'Fiji',
        'Kiribati',
        'Marshall Islands',
        'Micronesia',
        'Nauru',
        'New Zealand',
        'Palau',
        'Papua New Guinea',
        'Samoa',
        'Solomon Islands',
        'Tonga',
        'Tuvalu',
        'Vanuatu',
        'AU',
        'AUS',
        'NZ',
    ],
    China: ['China', 'Mongolia'],
    Korea: ['Korea', 'South Korea', 'South, Korea', 'Korea, South'],
    'APAC MD': [
        'Hong Kong',
        'HK',
        'Hong Kong - SAR',
        'Hong Kong-SAR',
        'Hong Kong SAR',
        'Macau',
        'Taiwan',
        'Singapore',
        'Malaysia',
        'Philippines',
    ],
    'APAC 2': [
        'Brunei',
        'Cambodia',
        'East Timor',
        'Indonesia',
        'Laos',
        'Myanmar',
        'Myanmar (Burma)',
        'Thailand',
        'Timor-Leste',
        'Vietnam',
        'Viet Nam',
    ],
    Japan: ['Japan'],
    CIS: [
        'Armenia',
        'Azerbaijan',
        'Belarus',
        'Georgia',
        'Kazakhstan',
        'Kyrgyzstan',
        'Russia',
        'Tajikistan',
        'Kyrgystan',
        'Turkmenistan',
        'Ukraine',
        'Uzbekistan',
        'Kazakshtan',
    ],
    'EU UK': [
        'Albania',
        'Andorra',
        'Austria',
        'Belgium',
        'Bosnia and Herzegovina',
        'Bosnia & Herzegovina',
        'Bulgaria',
        'Croatia',
        'Czech Republic',
        'Denmark',
        'Estonia',
        'Faroe Islands',
        'Finland',
        'France',
        'Germany',
        'Greece',
        'Holy See',
        'Hungary',
        'Iceland',
        'Ireland',
        'Italy',
        'Latvia',
        'Northern Ireland',
        'Liechtenstein',
        'Lithuania',
        'Luxembourg',
        'Malta',
        'Moldova',
        'Monaco',
        'Montenegro',
        'Netherlands',
        'North Macedonia',
        'Norway',
        'Poland',
        'Portugal',
        'Romania',
        'San Marino',
        'Serbia',
        'Slovakia',
        'Slovenia',
        'Spain',
        'Sweden',
        'Switzerland',
        'United Kingdom',
        'United Kindom',
        'UK',
        'England',
        'Scotland',
        'Wales',
        'Switzerland.Switzerland',
    ],
    USCA: ['Canada', 'USA', 'United States of America', 'United States', 'US', 'Estados Unidos', 'Guam'],
    LATAM: [
        'Antigua and Barbuda',
        'Argentina',
        'Bahamas',
        'Barbados',
        'Belize',
        'Bolivia',
        'Brazil',
        'Chile',
        'Colombia',
        'Costa Rica',
        'Cuba',
        'Dominica',
        'Dominican Republic',
        'Ecuador',
        'El Salvador',
        'Grenada',
        'Guatemala',
        'Guyana',
        'Haiti',
        'Honduras',
        'Jamaica',
        'Mexico',
        'Nicaragua',
        'Panama',
        'Paraguay',
        'Peru',
        'Saint Kitts and Nevis',
        'Saint Kitts & Nevis',
        'Saint Lucia',
        'Saint Vincent and the Grenadines',
        'Suriname',
        'Trinidad and Tobago',
        'Uruguay',
        'Venezuela',
        'Brasil',
        'Cayman Islands',
        'Trinidad & Tobago',
    ],
    MESATI: [
        'Afghanistan',
        'Algeria',
        'Angola',
        'Bahrain',
        'Bangladesh',
        'Benin',
        'Bhutan',
        'Botswana',
        'Burkina Faso',
        'Burundi',
        'Cabo Verde',
        'Cameroon',
        'Central African Republic',
        'Chad',
        'Comoros',
        'Congo',
        'Cyprus',
        'Democratic Republic of the Congo',
        'Djibouti',
        'Egypt',
        'Equatorial Guinea',
        'Eritrea',
        'Eswatini',
        'Ethiopia',
        'Gabon',
        'Gambia',
        'Ghana',
        'Guinea',
        'Guinea-Bissau',
        'Iran',
        'Islamic Rep. of Iran',
        'Iraq',
        'Israel',
        'Jordan',
        'Kenya',
        'Kuwait',
        'Lebanon',
        'Lesotho',
        'Liberia',
        'Libya',
        'Madagascar',
        'Malawi',
        'Maldives',
        'Mali',
        'Mauritania',
        'Mauritius',
        'Morocco',
        'Mozambique',
        'Namibia',
        'Nepal',
        'Niger',
        'Nigeria',
        'Oman',
        'Palestine State',
        'Qatar',
        'Rwanda',
        'Sao Tome and Principe',
        'Saudi Arabia',
        'Senegal',
        'Seychelles',
        'Sierra Leone',
        'Somalia',
        'South Africa',
        'South Sudan',
        'Sri Lanka',
        'Sudan',
        'Syria',
        'Tanzania',
        'Togo',
        'Tunisia',
        'Turkey',
        'Türkiye',
        'Uganda',
        'United Arab Emirates',
        'Yemen',
        'Zambia',
        'Zimbabwe',
        'UAE',
        'Cape Verde',
    ],
    India: ['India', 'Pakistan'],
    Global: ['Global Sales', 'Rest of World'],
};
const mapBillingCountryToRegion = (billingCountry) => {
    if (!billingCountry)
        return null;
    for (const region in exports.regionMapping) {
        if (exports.regionMapping[region].includes(initCapWords(billingCountry))) {
            return region;
        }
    }
    return null;
};
exports.mapBillingCountryToRegion = mapBillingCountryToRegion;
const countriesByRegion = (region) => {
    return exports.regionMapping[region];
};
exports.countriesByRegion = countriesByRegion;
//# sourceMappingURL=billingCountrySSMRegionMapping.js.map